import { Component, EventEmitter, Input, OnChanges, Output, SimpleChange, SimpleChanges, ViewChild, ChangeDetectionStrategy } from "@angular/core";
import { Task, TaskAction } from "../taskbook.types";
import { ITeam } from "@teammood/team";
import { Reactions, Thread, TimelineItemType } from "@teammood/timeline";
import { UserInfos } from "../../shared/ui/username-icon/user-infos.type";
import { ThreadsComponent } from "../../timeline/threads/threads.component";

@Component({
    selector: 'task',
    templateUrl: './task.component.html',
    styleUrls: ['./task.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class TaskComponent implements OnChanges {

    animated: string = '';
    icon: string;
    newThread: Thread;

    @Input() task: Task;
    @Input() userId: string;
    @Input() userInfos: UserInfos;
    @Input() teams: ITeam[];
    @Input() threadInCreation: boolean;

    @Output() onAction = new EventEmitter<{ threadContent: Thread }>()
    @Output() onReportTaskContent = new EventEmitter()

    @ViewChild('threadsComponent')
    private threadsComponent: ThreadsComponent;

    constructor(){}

    ngOnChanges(changes: SimpleChanges){
        if(changes.task){
            this.task = changes.task.currentValue;
        }
    }

    protected discuss() {
        this.threadInCreation = true; 
    }
    

    async onThreadCreation(newThread: Thread){
        if(newThread){
            this.onAction.emit({threadContent: newThread})
            this.threadInCreation = false;
        }
    }

    async onCancelCreation(){
        this.onAction.emit(null)
        this.threadInCreation = false;
    }

    protected onReacted(task: {id: string, itemType: TimelineItemType} & Reactions): void {
        this.task.reactions = task.reactions;
    }

    protected onReported(): void {
        this.onReportTaskContent.emit()
    }
}